/** @format */
import {ReactNode} from 'react';

import {Root} from './styles';
import MainLayoutNew from '../MainLayoutNew';

interface Props {
  children: ReactNode;
}

const ScreenLayout = ({children}: Props) => {
  return (
    <Root>
      <MainLayoutNew>{children}</MainLayoutNew>
    </Root>
  );
};

export {ScreenLayout};
